<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Ajout d'un mémo</div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" *ngIf="formGroup">
                <frg-form-input placeholder="Saisir le mémo ou l'alarme ici..." label="Mémo" id="alarme" type="textarea" nbRows="5"
                    [formGroup]="formGroup" [control]="formGroup.get('alarme')" required="true"
                    [errorMessage]="formGroup.get('alarme').errors?.maxlength ? '250 caractères maximum' : 'Ce champ est requis'">
                </frg-form-input>
                <div class="ngselect-container input-container" [ngClass]="{'sizeup': formGroup.get('destinataire').errors && formGroup.get('destinataire').touched}">
                    <label for="destinataire" class="label">Destinataire(s)<span *ngIf="true">*</span></label>
                    <ng-select id="destinataire"
                        [items]="destinataires"
                        [multiple]="true"
                        bindLabel="libelle"
                        bindValue="id"
                        [closeOnSelect]="false"
                        [clearable]="true"
                        formControlName="destinataire"
                        (change)="onDestinatairesChange()"
                        placeholder="Sélectionnez les destinataires"
                        class="input">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngIf="items.length === destinataires.length">
                                <span class="ng-value-label">Tout le cabinet</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length === 1 && items[0].id !== 'ALL'">
                                <span class="ng-value-label">{{items[0].libelle}}</span>
                                <span class="ng-value-icon right" (click)="clear(items[0])" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1 && items.length !== destinataires.length">
                                <span class="ng-value-label">{{items.length}} destinataire(s) sélectionné(s)</span>
                            </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" style="pointer-events: none;" /> {{item.libelle}}
                        </ng-template>
                    </ng-select>
                    <div class="error-container" [ngClass]="{'no-height': (!formGroup.get('destinataire').errors || !formGroup.get('destinataire').touched)}">
                        Veuillez sélectionner au moins un destinataire
                    </div>
                </div>
                <frg-form-input label="Date de début" id="dateDebut" type="date" placeholder="JJ/MM/AAAA"
                    [formGroup]="formGroup" [control]="formGroup.get('dateDebut')" required="true" [minDate]="minDate">
                </frg-form-input>
                <!--Suppression de la saisie de la date de fin pour l'instant -->

                <!-- <frg-form-input label="Date de fin" id="dateFin" type="date" placeholder="JJ/MM/AAAA"
                    [formGroup]="formGroup" [control]="formGroup.get('dateFin')" [minDate]="minDate">
                </frg-form-input> -->
                <!-- <frg-form-input label="Intervalle" id="typeOccurence" type="ngSelect" [formGroup]="formGroup"
                    [control]="formGroup.get('typeOccurence')" [selectValue]="typeOccurence" [isClearableSelect]="true">
                </frg-form-input>
                <frg-form-input id="delaiOccurence" type="ngSelect" [formGroup]="formGroup"
                    [control]="formGroup.get('delaiOccurence')" [selectValue]="delaiOccurence"
                    [isClearableSelect]="true">
                </frg-form-input> -->

                <div class="button-wrapper">
                    <frg-button (activated)="closeAddEditModal()" [backgroundColor]="'var(--darkest-primary)'"
                        [type]="'reset'">Quitter</frg-button>
                    <frg-button (activated)="onSubmit()" [backgroundColor]="'var(--primary)'">Ajouter
                    </frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>
